export default __webpack_public_path__ + "static/media/logo_wosp.63ce01a6.png";